// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2156":"064158ed","2839":"0d6fb767","9086":"c7d2b47f"}[chunkId] + ".css";
};